import { Box, Chip, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { appointmentStatus } from "../../app/apiManager/channelingStatusService";
import {
  getDoctor,
  getDoctorSpecialization,
} from "../../app/apiManager/doctorServices";
import { getPatientById } from "../../app/apiManager/patientServices";
import ContentCard from "../../components/ContentCard/ContentCard";
import DoctorSummery from "../../components/DoctorSummery/DoctorSummery";
import FlexBox from "../../components/FlexBox/FlexBox";
import TitleAndContent from "../../components/TitleAndContent/TitleAndContent";
import { APPOINTMENT_STATUS, PAYMENT_METHODS } from "../../const";
import { clearAll } from "../../reducers/appointmentInfoSlice";
import {
  clearAppointmentStatus,
  setAppointment,
} from "../../reducers/appointmentStatusSlice";
import {
  getAppointmentV2,
  getBillData,
} from "../../app/apiManager/appointmentService";

const StepOne = ({
  setActiveStep,
  doctor,
  setDoctor,
  setAppointmentCompleted,
  setAppointmentCancelled,
}) => {
  const { phoneNo } = useSelector((state) => state.appointmentInfo);
  const { patientEmail } = useSelector((state) => state.appointmentInfo);
  const storedAppointment = useSelector(
    (state) => state.appointmentStatus.appointment
  );
  const [patient, setPatient] = useState({});
  const [appointment, setAppointment] = useState(null);

  const [queryParams, setQueryParams] = useSearchParams();
  const [doctorSpecialization, setDoctorSpecialization] = useState("");
  const [patientDetails, setPatientDetails] = useState({});
  const [requestAttempt, setRequestAttempt] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(-1);
  const [channelingStatus, setChannelingStatus] = useState({
    status: "Apointment Confirmed",
    color: "darkgreen",
  });
  const dispatch = useDispatch();
  const [billData, setBillData] = useState({});

  console.log(billData);

  const loadAppointmentDetails = async () => {
    try {
      const appointmentId = queryParams.get("appointmentId");
      const appointmentResponse = await getAppointmentV2({
        Id: appointmentId,
      });
      console.log(appointment);
      if (
        Array.isArray(appointmentResponse.appointments) &&
        appointmentResponse.appointments.length > 0
      ) {
        setAppointment(appointmentResponse.appointments[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getbillData = async () => {
    try {
      const billResponse = await getBillData({
        appointmentId: queryParams.get("appointmentId"),
      });

      if (Array.isArray(billResponse) && billResponse.length > 0) {
        setBillData(billResponse[0]);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const appointmentId = queryParams.get("appointmentId");
    dispatch(clearAll());
    loadAppointmentDetails();
    getbillData();
    console.log(appointmentId);
  }, []);

  let paymentChipText = "Loading...";

  switch (paymentMethod) {
    case 1:
      paymentChipText = "Online Payment";
      break;

    case PAYMENT_METHODS.PROMO:
      paymentChipText = "Promo";
      break;

    case PAYMENT_METHODS.CASH_PAYMENT:
      paymentChipText = "Cash Payment";
      break;

    default:
      break;
  }

  return (
    <>
      <Box pb={1.2}>
        <Typography
          fontWeight={"bold"}
          fontSize={"1.5rem"}
          sx={{
            color: channelingStatus.color,
          }}
        >
          {channelingStatus.status}
        </Typography>
      </Box>

      <Grid container columnSpacing={1.5} rowSpacing={1}>
        <Grid item xs={12} sm={7}>
          <ContentCard
            sx={{
              pl: { sm: 2 },
              pb: 3,
              boxShadow: 0.5,
              border: "1px solid #ececec",
            }}
          >
            <DoctorSummery
              doctorImage={
                doctor.doctorId
                  ? `${process.env.REACT_APP_VC_DOMAIN}${process.env.REACT_APP_IMAGE_PATH}/${doctor.doctorId}.png`
                  : null
              }
              name={appointment?.DoctorName ? appointment.DoctorName : ""}
              qualifications={`${appointment?.DoctorSpecializations || ""} ${
                appointment?.RegistrationNumber && doctor.IsSLMCHide === false
                  ? "REG No :" + appointment.RegistrationNumber
                  : ""
              }`}
            />
            <Grid container mt={3}>
              <Grid item xs>
                <TitleAndContent
                  title={"Appointment No"}
                  content={appointment ? appointment.Number : ""}
                />
              </Grid>
              <Grid item xs>
                <TitleAndContent
                  title={"Appointment Date"}
                  content={
                    appointment
                      ? new Date(appointment.TimeStart).toLocaleDateString()
                      : ""
                  }
                />
              </Grid>
              <Grid item xs>
                <TitleAndContent
                  title={"Appointment Time"}
                  content={
                    appointment
                      ? new Date(
                          appointment.TimeStart.replace(".000Z", "")
                        ).toLocaleTimeString()
                      : ""
                  }
                />
              </Grid>
            </Grid>

            <Grid container mt={4}>
              <Grid item xs>
                <TitleAndContent
                  title={"Patient Name"}
                  content={`${appointment?.Title || ""} ${
                    appointment?.FirstName || ""
                  } ${appointment?.LastName || ""}`}
                />
              </Grid>
              <Grid item xs>
                <TitleAndContent
                  title={"Mobile no"}
                  content={appointment?.Mobile ? appointment.Mobile : "-"}
                />
              </Grid>
              <Grid item xs>
                <TitleAndContent
                  title={"Email"}
                  content={appointment?.Email ? appointment.Email : "-"}
                />
              </Grid>
            </Grid>
          </ContentCard>
        </Grid>

        <Grid item xs>
          {/* <ContentCard sx={{ boxShadow: 0.5, border: "1px solid #ececec" }}>
            <Typography fontWeight={"bold"} fontSize={"1.2rem"}>
              Payment Details
            </Typography>
            <Box display={"flex"} flexDirection="column" gap={1} mt={2}>
              <TitleAndContent
                title={"Channeling fee"}
                content="Rs. 500.00"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              />
              <TitleAndContent
                title={"Service Charges"}
                content="Rs. 250.00"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              />

              <Divider orientation="horizontal" />
              <FlexBox sx={{ justifyContent: "end", gap: 2 }}>
                <Typography fontWeight={"bold"} sx={{ color: "#787A91" }}>
                  Total :
                </Typography>
                <Typography fontWeight={"bold"}>Rs. 750.00</Typography>
              </FlexBox>
            </Box>
          </ContentCard> */}

          <ContentCard
            sx={{
              boxShadow: 0.5,
              border: "1px solid #ececec",
              display: "flex",
              flexDirection: "column",
              gap: 0.6,
              alignItems: "start",
              padding: 2,
            }}
          >
            <Typography fontWeight="bold" fontSize="1.2rem">
              Payment Method
            </Typography>
            {/* <Typography>{billData?.bill?.PaymentStatus}</Typography> */}

            {billData?.bill?.PaymentStatus !== "Online Payment" && (
              <Typography>*Please make the payment to reception</Typography>
            )}
            <>
              {billData?.billData?.map((item, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {item.ItemName}
                  <span>
                    Rs. {parseFloat(item.Amount || item.TotalFee).toFixed(2)}
                  </span>
                </Typography>
              ))}

              <Divider
                sx={{ width: "100%", my: 1, borderColor: "lightgray" }}
              />

              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                Discount (-)
                <span>
                  Rs. {parseFloat(billData?.bill?.Discount).toFixed(2)}
                </span>
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                Total
                <span>
                  Rs.
                  {(
                    parseFloat(billData?.bill?.Total) -
                    parseFloat(billData?.bill?.Discount)
                  ).toFixed(2)}
                  /=
                </span>
              </Typography>

              <Divider
                sx={{ width: "100%", my: 0.5, borderColor: "lightgray" }}
              />
              <Divider sx={{ width: "100%", borderColor: "lightgray" }} />
            </>
          </ContentCard>
        </Grid>
      </Grid>
    </>
  );
};

export default StepOne;
